import React from 'react';

import Layout from 'layouts/Layout';
import CommercialOrder from './CommercialOrder';

const CommercialOrderLayout = ({ match }) => <Layout component={CommercialOrder} match={match} />;

export default CommercialOrderLayout;
